import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { AttachmentDetailsFragment } from 'generated/graphql';

import { ToastrService } from 'core/toastr.service';
import { WindowRef } from 'core/window-ref.service';

@Component({
  selector: 'app-attachment-button',
  templateUrl: './attachment-button.component.html'
})
export class AttachmentButtonComponent implements OnInit {
  fileLink$: Observable<string>;

  @Input() attachment: AttachmentDetailsFragment;

  constructor(
    private _windowRef: WindowRef,
    private _http: HttpClient,
    private _toastrService: ToastrService,
    private _matDialog: MatDialog
  ) {
  }

  openImageInDialog(tmpl: TemplateRef<any>): void {
    this._matDialog.open(tmpl);
  }

  ngOnInit(): void {
    this.fileLink$ = this.fileLink(this.attachment);
  }

  isImage(attachment: AttachmentDetailsFragment) {
    return attachment.mimeType.includes('image');
  }

  fileLink(attachment: AttachmentDetailsFragment) {
    const url = `${environment.apiBase}${attachment.downloadUrl}`;

    return this._http.get(url).pipe(
      map((res: any) => res.download_url as string),
      take(1),
      shareReplay()
    );
  }

  attachmentClicked(attachment: AttachmentDetailsFragment) {
    this._toastrService.info('Downloading File...');
    this.fileLink(attachment).subscribe(
      (url) => this._windowRef.nativeWindow.location.href = url
    );
  }

}
